<template>
  <!--begin::Dashboard-->
  <div class="p-5 container" :key="componentKey">
    <div class="row mb-5" style="padding: 2vh;">
      <div
        class="col-12 col-lg-6"
        style="font-style: normal;
                  font-weight: 500;
                  font-size: 30px;
                  line-height: 39px;
                  color: #000000;"
      >
        {{ myExam["title"] }}
        <!-- {{ answersList }} -->
      </div>
      <div
        class="col-12 col-lg-6"
        style="display: flex;flex-direction: row;flex-wrap: wrap;align-items: center;justify-content: space-around;"
      >
        <span
          style="font-style: normal;
                  font-weight: 500;
                  font-size: 20px;
                  line-height: 26px;
                  color: #000000;"
        >
          คำถามข้อที่
          <span style="color:#F2A17D">{{ page + 1 }}</span> /
          {{ listData ? listData.length : "0" }}</span
        >

        <button
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#kt_modal_answers"
          class="btn btn-info"
        >
          กระดาษคำตอบ
        </button>
        <button
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#kt_modal_calculator_exam"
          class="btn btn-secondary"
        >
          <i class="fa fa-calculator"></i> เครื่องคิดเลข
        </button>
        <span
          style="font-weight: 400;
                    font-size: 20px;
                    line-height: 26px;
                    color: #000000;"
        >
          <i class="fa fa-clock"></i> {{ countdown }}</span
        >
      </div>
      <div
        class="col-12 mt-5"
        :key="contentKey"
        v-if="listData && listData.length > 0 && listData[page]"
        style="background: #F7F7F7;
                  border: 1px solid #D8D8D8;
                  border-radius: 15px;
                  padding: 20px;"
      >
        <div class="row" style="position: relative;">
          <video
            v-if="isCameraOpen == true"
            ref="video"
            id="video"
            style="width: 200px;height:auto;position: absolute;"
            autoplay
          ></video>
          <div class="col-12 col-lg-8 offset-lg-2">
            <canvas
              style="display: none;"
              ref="canvas"
              id="canvas"
              width="640"
              height="480"
            ></canvas>
            <!-- <div v-for="(item, index) in captures" :key="index">
              <img v-bind:src="item" style="width: 100%" />
            </div> -->
            <p
              style="font-style: normal;
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 23px;"
            >
              {{ listData[page].textQuestion }}
            </p>
            <img
              v-if="listData[page].imageQuestion"
              :src="imageUrl + listData[page].imageQuestion"
              alt=""
            />

            <div
              class="row"
              v-if="listData[page].qType == 1 || listData[page].qtype == 1"
            >
              <div
                class="col-12 col-md-6 p-5"
                v-for="(itemA, indexA) in listData[page].questionChoices"
                :key="indexA"
              >
                <div
                  @click="setAnswer(listData[page].id, itemA.choiceId, 1, page)"
                  style="background: #FFFFFF;
                          border-radius: 10px;
                          height: 100%;
                          padding: 20px;"
                >
                  <img
                    v-if="itemA.imageChoice"
                    :src="imageUrl + itemA.imageChoice"
                    class="w-100"
                    alt=""
                  />
                  <div
                    class="form-check form-check-custom form-check-success form-check-solid my-3"
                  >
                    <input
                      class="form-check-input"
                      type="radio"
                      :name="'qId' + listData[page].id"
                      :value="itemA.choiceId"
                      :id="'qaId' + itemA.choiceId"
                      @click="
                        setAnswer(listData[page].id, itemA.choiceId, 1, page)
                      "
                      :checked="answer[page] == itemA.choiceId ? true : false"
                    />
                    <!-- v-model="answer[page]" -->

                    <label
                      class="form-check-label"
                      :for="'qaId' + itemA.choiceId"
                    >
                      {{ itemA.textChoice }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="my-5">
              <input
                type="text"
                v-model="answer[page]"
                class="form-control"
                @change="setAnswer(listData[page].id, answer[page], 2, page)"
              />
            </div>
            <div style="display: flex;justify-content: space-between;">
              <button
                type="button"
                @click="previousPage()"
                :disabled="page == 0"
                class="btn btn-exam"
              >
                ก่อนหน้า
              </button>
              <button
                v-if="page == listData.length - 1"
                :disabled="submitButton"
                type="button"
                @click="submit()"
                class="btn btn-exam"
              >
                <span
                  v-if="submitButton"
                  class="spinner-border spinner-border-sm me-2"
                  role="status"
                ></span>
                {{ submitButton ? "กำลังส่ง..." : "ส่งคำตอบ" }}
              </button>
              <button
                v-else
                type="button"
                @click="nextPage()"
                class="btn btn-exam"
              >
                ถัดไป
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="kt_modal_answers"
    tabindex="-1"
    aria-hidden="true"
  >
    <!--begin::Modal dialog-->
    <div class="modal-dialog modal-dialog-centered mw-650px">
      <!--begin::Modal content-->
      <div class="modal-content">
        <!--begin::Modal header-->
        <div class="modal-header" id="kt_modal_answers_header">
          <!--begin::Modal title-->
          <h2>กระดาษคำตอบ</h2>
          <button
            v-if="videoSkip"
            type="button"
            class="btn btn-sm btn-warning ms-3"
            @click="autoAnswer()"
          >
            ตอบอัตโนมัติ
          </button>
          <!-- {{answer}} -->
          <!--end::Modal title-->
          <!--begin::Close-->
          <div
            class="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
            </span>
          </div>
        </div>
        <div
          class="modal-body py-10 px-lg-17"
          v-if="listData && listData.length > 0"
        >
          <div
            v-for="(item, index) in listData"
            :key="index"
            :id="item.qaId"
            class="subject "
          >
            <span
              ><button
                :class="[
                  'btn btn-sm w-80px my-2',
                  answer[index] ? 'btn-primary' : 'btn-warning',
                ]"
                data-bs-dismiss="modal"
                @click="changePage(index)"
              >
                ข้อ {{ index + 1 }}.</button
              >&nbsp;&nbsp;&nbsp;
              <span
                v-if="listData[index].qType == 1 || listData[index].qtype == 1"
              >
                <span
                  v-for="(item, indexA) in item.questionChoices"
                  :key="indexA"
                  :class="
                    item.choiceId == answer[index]
                      ? 'choice green'
                      : 'choice grey'
                  "
                  >{{ indexA + 1 }}</span
                >
              </span>
              <span v-else class="mx-5">
                {{ answer[index] ? answer[index].toString() : "" }}
              </span>
            </span>
          </div>
        </div>
        <div class="modal-body py-10 px-lg-17" v-else>
          <p class="text-center">ไม่พบข้อมูลคำถาม</p>
        </div>
        <div class="modal-footer flex-center"></div>
      </div>
    </div>
  </div>
  <!-- calculator modal -->
  <div
    class="modal fade"
    id="kt_modal_calculator_exam"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      id="kt_modal_calculator_exam_dialog"
      style="max-width:320px;margin-left:1.75rem;"
    >
      <div class="modal-content">
        <div
          class="modal-header"
          id="kt_modal_calculator_exam_header"
          style="cursor:move;"
        >
          <h2><i class="fa fa-calculator me-2"></i>เครื่องคิดเลข</h2>
          <div
            class="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-4">
          <div
            style="background:#1a1a2e;border-radius:10px;padding:12px 14px;margin-bottom:12px;text-align:right;"
          >
            <div
              style="color:#888;font-size:13px;min-height:18px;word-break:break-all;"
            >
              {{ calcExpression || "&nbsp;" }}
            </div>
            <div
              style="color:#fff;font-size:32px;font-weight:700;word-break:break-all;"
            >
              {{ calcDisplay }}
            </div>
          </div>
          <div
            style="display:grid;grid-template-columns:repeat(4,1fr);gap:8px;"
          >
            <button
              @click="calcClear()"
              class="calc-btn calc-btn-fn"
              style="grid-column:span 2;"
            >
              AC
            </button>
            <button @click="calcInput('⌫')" class="calc-btn calc-btn-fn">
              ⌫
            </button>
            <button @click="calcInput('/')" class="calc-btn calc-btn-op">
              ÷
            </button>

            <button @click="calcInput('7')" class="calc-btn">7</button>
            <button @click="calcInput('8')" class="calc-btn">8</button>
            <button @click="calcInput('9')" class="calc-btn">9</button>
            <button @click="calcInput('*')" class="calc-btn calc-btn-op">
              ×
            </button>

            <button @click="calcInput('4')" class="calc-btn">4</button>
            <button @click="calcInput('5')" class="calc-btn">5</button>
            <button @click="calcInput('6')" class="calc-btn">6</button>
            <button @click="calcInput('-')" class="calc-btn calc-btn-op">
              −
            </button>

            <button @click="calcInput('1')" class="calc-btn">1</button>
            <button @click="calcInput('2')" class="calc-btn">2</button>
            <button @click="calcInput('3')" class="calc-btn">3</button>
            <button
              @click="calcInput('+')"
              class="calc-btn calc-btn-op"
              style="grid-row:span 2;"
            >
              +
            </button>

            <button
              @click="calcInput('0')"
              class="calc-btn"
              style="grid-column:span 2;"
            >
              0
            </button>
            <button @click="calcInput('.')" class="calc-btn">.</button>

            <button
              @click="calcEqual()"
              class="calc-btn calc-btn-eq"
              style="grid-column:span 4;"
            >
              =
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- dialog score -->
  <!-- <el-button text @click="dialogVisible = true">
    click to open the Dialog
  </el-button> -->

  <el-dialog
    v-model="dialogVisible"
    title=""
    width="536px"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    align-center
  >
    <div style="padding:8px 0 0;">
      <!-- Title row -->
      <div style="text-align:center;margin-bottom:24px;">
        <span
          style="display:inline-flex;align-items:center;justify-content:center;width:48px;height:48px;border-radius:50%;background:#e6f9f0;margin-bottom:12px;"
        >
          <i class="fa fa-check" style="color:#22c55e;font-size:22px;"></i>
        </span>
        <h2 style="font-size:18px;font-weight:700;margin:0 0 4px;">
          {{ resultData.title }}
        </h2>
        <p style="color:#3b4a56;margin:0;font-size:14px;">
          {{ resultData.subtitle }}
        </p>
      </div>

      <!-- Info card -->
      <div
        style="background:#f7f7f7;border:1px solid #d8d8d8;border-radius:15px;padding:20px 24px;display:flex;align-items:center;"
      >
        <div style="flex:1;display:flex;flex-direction:column;gap:10px;">
          <div style="display:flex;align-items:center;gap:8px;">
            <i
              class="fa fa-book-open"
              style="color:#6b6b6b;font-size:16px;width:20px;text-align:center;"
            ></i>
            <span style="color:#6b6b6b;font-size:13px;"
              >จำนวนข้อสอบ : {{ resultData.totalQuestion }} ข้อ</span
            >
          </div>
          <div style="display:flex;align-items:center;gap:8px;">
            <i
              class="fa fa-file-alt"
              style="color:#6b6b6b;font-size:16px;width:20px;text-align:center;"
            ></i>
            <span style="color:#6b6b6b;font-size:13px;"
              >คะแนนเต็ม : {{ resultData.totalScore }} คะแนน</span
            >
          </div>
          <div style="display:flex;align-items:center;gap:8px;">
            <i
              class="fa fa-check-circle"
              style="color:#6b6b6b;font-size:16px;width:20px;text-align:center;"
            ></i>
            <span style="color:#6b6b6b;font-size:13px;"
              >เกณฑ์การผ่าน : {{ resultData.percentPass }}%</span
            >
          </div>
          <div style="display:flex;align-items:center;gap:8px;">
            <i
              class="fa fa-stopwatch"
              style="color:#6b6b6b;font-size:16px;width:20px;text-align:center;"
            ></i>
            <span style="color:#6b6b6b;font-size:13px;"
              >เวลาในการทำข้อสอบ : {{ resultData.timeSubmit }} นาที</span
            >
          </div>
        </div>

        <div
          style="width:1px;align-self:stretch;background:#d8d8d8;margin:0 20px;"
        ></div>

        <div
          style="flex-shrink:0;display:flex;flex-direction:column;align-items:center;gap:6px;"
        >
          <p style="font-size:16px;font-weight:700;color:#000;margin:0;letter-spacing:-0.3px;">ผลการทดสอบ</p>
          <span
            v-if="resultData.passed"
            style="display:inline-flex;align-items:center;justify-content:center;height:42px;padding:3px 12px;border-radius:6px;background:#e0f1e7;"
          >
            <span style="font-size:20px;font-weight:700;color:#109448;">ผ่าน</span>
          </span>
          <span
            v-else
            style="display:inline-flex;align-items:center;justify-content:center;height:42px;padding:3px 12px;border-radius:6px;background:#ffdee2;"
          >
            <span style="font-size:20px;font-weight:700;color:#d20000;">ไม่ผ่าน</span>
          </span>
        </div>
      </div>

      <!-- Button -->
      <div
        style="text-align:center;margin-top:24px;display:flex;gap:12px;justify-content:center;flex-wrap:wrap;"
      >
        <button
          type="button"
          style="min-width:250px;height:58px;font-size:16px;font-weight:500;border-radius:15px;background:#323563;color:#fff;border:none;"
          @click="onBack()"
        >
          กลับไปยังหน้าหลัก
        </button>
        <button
          type="button"
          style="min-width:250px;height:58px;font-size:16px;font-weight:500;border-radius:15px;background:#fff;color:#323563;border:1px solid #323563;"
          @click="dialogSurveyVisible = true"
        >
          กรุณาตอบแบบสำรวจความพึงพอใจ
        </button>
      </div>
    </div>
  </el-dialog>

  <el-dialog
    v-model="dialogSurveyVisible"
    title=""
    width="1024px"
    :show-close="true"
    align-center
  >
    <div style="text-align:right;margin-bottom:12px;">
      <a
        href="https://forms.gle/HTcZF2y9hBN9ebzr5"
        target="_blank"
        rel="noopener noreferrer"
        class="btn btn-sm btn-light-primary"
      >
        <i class="fa fa-external-link-alt"></i> เปิดในแท็บใหม่
      </a>
    </div>
    <iframe
      src="https://docs.google.com/forms/d/e/1FAIpQLSd9yOUDteG-me0s44L8xNfPiWnvXeOIy3OOZgrL7y3JKXRj6A/viewform?embedded=true"
      width="1024"
      height="1024"
      frameborder="0"
      style="max-width:100%;border:none;"
      >กำลังโหลด…</iframe
    >
  </el-dialog>
</template>
<script lang="ts">
/* eslint-disable */
import { defineComponent, nextTick, onMounted, ref } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import axios from "axios";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import jQuery from "jquery";
import { useCookies } from "vue3-cookies";
const $ = jQuery;
const customColorMethod = (percentage: number) => {
  if (percentage < 60) {
    return "#f56c6c";
  }
  return "#67c23a";
};
const dialogVisible = ref(false);
const dialogSurveyVisible = ref(false);
const video = ref();
const canvas = ref();
const captures = ref([] as Array<object>);
const isCameraOpen = ref(false);
const listData = ref();
const page = ref(0);
const score = ref(0);
const contentKey = ref(0);
const answer = ref([] as Array<object>);
const answersList = ref<
  Array<{ questionId: any; choiceId: any[]; answerUser: any }>
>([]);
import router from "@/router";
import { L } from "@fullcalendar/list/internal-common";
const { cookies } = useCookies();
const submitButton = ref(false);
const resultData = ref({
  passed: false,
  title: "",
  subtitle: "",
  totalQuestion: 0,
  totalScore: 0,
  percentPass: 0,
  timeSubmit: "",
  userScore: 0,
  percent: 0,
});
const currentSyllabusId = ref("");
export default defineComponent({
  name: "exam-test",
  components: {},
  data() {
    return {
      checkPermission: 0,
      timeInSecs: 0,
      ticker: 0,
      imageUrl: process.env.VUE_APP_IMG_URL,
      videoSkip: process.env.VUE_APP_VIDEO_SKIP === "true",
      countdown: "",
      dataParams: this.$route.params,
      localStream: {
        srcObject: "",
      },
      examRoomProfile: "",
      componentKey: 0,
      percentPass: 0,
      currentScore: 0,
      currentScoreUser: 0,
      currentPercent: 0,
      currentTimeSubmit: "",
      myExam: [],
      startTestDate: "",
      calcDisplay: "0",
      calcExpression: "",
      calcHasResult: false,
    };
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const examQuestionKey =
      "ExamQuestion_" +
      localStorage.getItem("u_id") +
      "_" +
      route.params.exId +
      "_" +
      route.params.exrId;
    const answersListKey =
      "ExamAnswersList_" +
      localStorage.getItem("u_id") +
      "_" +
      route.params.exId +
      "_" +
      route.params.exrId;
    onMounted(async () => {
      answersList.value = [];
      await getDataList();
    });
    const restoreAnswers = () => {
      const savedAnswers = localStorage.getItem(answersListKey);
      if (savedAnswers) {
        answersList.value = JSON.parse(savedAnswers);
        const restored: any[] = [];
        answersList.value.forEach((item) => {
          if (item.choiceId && item.choiceId.length > 0) {
            const idx = listData.value.findIndex(
              (q) => q.id === item.questionId,
            );
            if (idx !== -1) restored[idx] = item.choiceId[0];
          } else if (item.answerUser) {
            const idx = listData.value.findIndex(
              (q) => q.id === item.questionId,
            );
            if (idx !== -1) restored[idx] = item.answerUser;
          }
        });
        answer.value = restored;
      }
    };
    const getDataList = async () => {
      const responseData = await axios.get(
        process.env.VUE_APP_API_URL +
          "/getExamRoomRegister?examRoomId=" +
          route.params.exrId +
          "&isDetail=true",
        {
          headers: {
            token: localStorage.getItem("id_token"),
          },
        },
      );
      currentSyllabusId.value =
        responseData.data.data.content[0].examRoomProfile.syllabusId;
      const cached = localStorage.getItem(examQuestionKey);
      if (cached) {
        listData.value = JSON.parse(cached);
        restoreAnswers();
        return;
      }
      return axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getExamQuestion?examId=" +
            route.params.exId +
            "&syllabusId=" +
            currentSyllabusId.value +
            "&examRoomId=" +
            route.params.exrId,

          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          },
        )
        .then((response) => {
          listData.value = response.data.data;
          if (listData.value.length > 0) {
            localStorage.setItem(
              examQuestionKey,
              JSON.stringify(listData.value),
            );
          }
          restoreAnswers();
        })
        .catch((error) => {
          // console.log(error);
        });
    };
    const previousPage = () => {
      page.value = page.value - 1;
      contentKey.value += 1;
    };
    const nextPage = () => {
      page.value = page.value + 1;
      contentKey.value += 1;
    };
    const changePage = (event) => {
      page.value = event;
      contentKey.value += 1;
    };
    const setDataInArrayObjectById = (array, id, answer, type) => {
      const foundObject = array.find((obj) => obj.questionId === id);
      if (!foundObject) {
        return false;
      }
      if (type == 1) {
        foundObject["choiceId"] = [answer];
        foundObject["answerUser"] = "";
      } else {
        foundObject["choiceId"] = [];
        foundObject["answerUser"] = answer;
      }
    };
    const setAnswer = (qId, dataAnswer, type, page) => {
      // console.log("setAnswer");
      const list: any = {};
      if (answersList.value.length > 0) {
        console.log(answersList.value);
        if (
          setDataInArrayObjectById(answersList.value, qId, dataAnswer, type) ==
          false
        ) {
          if (type == 1) {
            answer.value[page] = dataAnswer;
            list.questionId = qId;
            list.choiceId = [dataAnswer];
            list.answerUser = "";
          } else {
            list.questionId = qId;
            list.choiceId = [];
            list.answerUser = dataAnswer;
          }
        } else {
          if (type == 1) answer.value[page] = dataAnswer;
        }
      } else {
        if (type == 1) {
          answer.value[page] = dataAnswer;
          list.questionId = qId;
          list.choiceId = [dataAnswer];
          list.answerUser = "";
        } else {
          list.questionId = qId;
          list.choiceId = [];
          list.answerUser = dataAnswer;
        }
      }
      if (list.questionId) {
        answersList.value.push(list);
      }
      // console.log(answer.value);
      // console.log(answersList.value);
      // console.log(answersList.value);
      localStorage.setItem(answersListKey, JSON.stringify(answersList.value));
      // localStorage.setItem("qId" + qId, qaId);
    };

    return {
      getDataList,
      listData,
      page,
      previousPage,
      nextPage,
      answer,
      changePage,
      setAnswer,
      dialogSurveyVisible,
      video,
      canvas,
      captures,
      isCameraOpen,
      route,
      answersList,
      setDataInArrayObjectById,
      contentKey,
      customColorMethod,
      dialogVisible,
      submitButton,
      answersListKey,
      resultData,
      currentSyllabusId,
    };
  },
  created() {
    this.forceRerender();
  },
  async mounted() {
    this.initCalculatorDrag();
    if (localStorage.getItem("reloaded")) {
      localStorage.removeItem("reloaded");
      this.componentKey += 1;
      page.value = 0;
    }
    const exam = await axios.get(
      process.env.VUE_APP_API_URL + "/getExam?id=" + this.$route.params.exId,
      {
        headers: {
          token: localStorage.getItem("id_token"),
        },
      },
    );

    this.myExam = exam.data.data.content[0];
    this.percentPass = exam.data.data.content[0].percentPass;
    // console.log("getExam");
    // console.log(this.myExam);
    setCurrentPageBreadcrumbs(this.myExam["title"], []);

    // if (isCameraOpen.value == false) {
    //   console.log(video.value);
    // }
    const exData = await axios.get(
      process.env.VUE_APP_API_URL +
        "/getExamRoomRegister?examRoomId=" +
        this.$route.params.exrId +
        "&isDetail=true",
      {
        headers: {
          token: localStorage.getItem("id_token"),
        },
      },
    );
    this.examRoomProfile = exData.data.data.content[0].examRoomProfile;
    this.startTestDate = exData.data.data.content[0].startTestDate || "";
    const endTestDate = exData.data.data.content[0].endTestDate;
    const alreadySubmitted = endTestDate != null && endTestDate != "";
    currentSyllabusId.value =
      exData.data.data.content[0].examRoomProfile.syllabusId;

    const goBackHome = () => {
      router.push({
        name:
          this.$route.name === "exam-test-noheader" ? "my-exam" : "home",
      });
    };

    if (alreadySubmitted) {
      await Swal.fire({
        title: "ไม่สามารถทำข้อสอบได้",
        text: "คุณได้ส่งคำตอบไปแล้ว ไม่สามารถทำข้อสอบซ้ำได้",
        icon: "warning",
        confirmButtonColor: "#323563",
        showCancelButton: false,
        confirmButtonText: "กลับสู่หน้าหลัก",
        cancelButtonText: "ปิด",
        allowOutsideClick: false,
      }).then(() => {
      goBackHome();
      });
      return;
    }

    const status = exData.data.data.content[0].status;
    if (exData.data.code != 200 || (status != 0 && status != 1)) {
      await Swal.fire({
        title: "ไม่สามารถทำข้อสอบได้",
        text: "คุณได้ส่งคำตอบไปแล้ว ไม่สามารถทำข้อสอบซ้ำได้",
        icon: "warning",
        confirmButtonColor: "#323563",
        showCancelButton: false,
        confirmButtonText: "กลับสู่หน้าหลัก",
        cancelButtonText: "ปิด",
        allowOutsideClick: false,
      }).then(() => {
        goBackHome();
      });
      return;
    }

    if (status == 1) {
      this.startTimer(this.calcRemainSecs());
      return;
    }

    Swal.fire({
      title: "แบบทดสอบ",
      text:
        "ระบบจะจับเวลาและบันทึกการทำข้อสอบทันที เมื่อคุณกดปุ่มเริ่มทำข้อสอบ",
      icon: "warning",
      showCancelButton: false,
      confirmButtonColor: "#323563",
      cancelButtonColor: "#d33",
      allowOutsideClick: false,
      confirmButtonText: "เข้าใจและเริ่มทำข้อสอบ",
      cancelButtonText: "กลับสู่หน้าหลัก",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append(
          "examRoomCode",
          this.examRoomProfile["examRoomCode"] + "",
        );
        formData.append(
          "examRoomPwd",
          this.examRoomProfile["examRoomPwd"] + "",
        );
        const startTestExamRoomRegister = await axios.post(
          process.env.VUE_APP_API_URL + "/startTestExamRoomRegister",
          formData,
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          },
        );
        this.startTestDate =
          startTestExamRoomRegister.data?.data?.startTestDate ||
          this.startTestDate ||
          new Date().toISOString();
        this.startTimer(this.calcRemainSecs());
      } else {
        router.push({
          name:
            this.$route.name === "exam-test-noheader"
              ? "exam-detail-noheader"
              : "exam-detail",
          params: { id: this.$route.params.exrId },
        });
      }
    });
  },
  methods: {
    // todo() {
    //   isCameraOpen.value = true;
    //   this.createCameraElement();
    //   window.setInterval(() => {
    //     this.capture();
    //   }, 2000); // interval set to one sec.
    // },
    // checkCamera() {
    //   this.checkPermission = window.setInterval(() => {
    //     if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    //       navigator.mediaDevices
    //         .getUserMedia({ video: true, audio: false })
    //         .then((stream) => {
    //           // console.log(stream);
    //         })
    //         .catch((error) => {
    //           clearInterval(this.checkPermission);
    //           console.log(error);
    //           Swal.fire({
    //             title: "กรุณาให้สิทธิ webcam ในการทำข้อสอบ",
    //             icon: "warning",
    //             showCancelButton: true,
    //             confirmButtonColor: "#323563",
    //             cancelButtonColor: "#d33",
    //             confirmButtonText: "เข้าใจและเริ่มทำข้อสอบ",
    //             allowOutsideClick: false,
    //             cancelButtonText: "กลับสู่หน้าหลัก",
    //           }).then((result) => {
    //             if (result.isConfirmed) {
    //               this.createCameraElement();
    //             } else {
    //               router.push({
    //                 name: "voluntary-detail",
    //                 params: { id: this.$route.params.exrId },
    //               });
    //             }
    //           });
    //         });
    //     }
    //   }, 2000);
    // },
    autoAnswer() {
      if (!listData.value) return;
      listData.value.forEach((question, idx) => {
        if (question.qType == 1 && question.questionChoices) {
          const correct = question.questionChoices.find(
            (c) => c.textChoice && c.textChoice.indexOf("ข้อนี้ถูก") !== -1,
          );
          if (correct) {
            answer.value[idx] = correct.choiceId;
            this.setAnswer(question.id, correct.choiceId, 1, idx);
          }
        }
      });
    },
    initCalculatorDrag() {
      const $header = $("#kt_modal_calculator_exam_header");
      const $dialog = $("#kt_modal_calculator_exam_dialog");
      let dragging = false;
      let startX = 0;
      let startY = 0;
      let startLeft = 0;
      let startTop = 0;

      $header.on("mousedown", (e: any) => {
        dragging = true;
        startX = e.pageX;
        startY = e.pageY;
        const offset = $dialog.offset();
        const width = $dialog.outerWidth();
        startLeft = offset.left;
        startTop = offset.top;
        $dialog.css({
          position: "fixed",
          margin: 0,
          width: width + "px",
          left: startLeft + "px",
          top: startTop + "px",
        });
        e.preventDefault();
      });

      $(document).on("mousemove", (e: any) => {
        if (!dragging) return;
        const newLeft = startLeft + (e.pageX - startX);
        const newTop = startTop + (e.pageY - startY);
        $dialog.css({
          left: newLeft + "px",
          top: newTop + "px",
        });
      });

      $(document).on("mouseup", () => {
        dragging = false;
      });
    },
    calcClear() {
      this.calcDisplay = "0";
      this.calcExpression = "";
      this.calcHasResult = false;
    },
    calcInput(val: string) {
      const ops = ["+", "-", "*", "/"];
      if (val === "⌫") {
        if (this.calcHasResult) {
          this.calcDisplay = "0";
          this.calcExpression = "";
          this.calcHasResult = false;
          return;
        }
        this.calcDisplay =
          this.calcDisplay.length > 1 ? this.calcDisplay.slice(0, -1) : "0";
        return;
      }
      if (ops.includes(val)) {
        this.calcExpression =
          (this.calcHasResult
            ? this.calcDisplay
            : this.calcExpression + this.calcDisplay) + val;
        this.calcDisplay = "0";
        this.calcHasResult = false;
        return;
      }
      if (this.calcHasResult) {
        this.calcDisplay = val === "." ? "0." : val;
        this.calcExpression = "";
        this.calcHasResult = false;
        return;
      }
      if (val === "." && this.calcDisplay.includes(".")) return;
      this.calcDisplay =
        this.calcDisplay === "0" && val !== "." ? val : this.calcDisplay + val;
    },
    calcEqual() {
      try {
        const expr = this.calcExpression + this.calcDisplay;
        const result = Function('"use strict"; return (' + expr + ")")();
        this.calcDisplay = String(parseFloat(result.toFixed(10)));
        this.calcExpression = expr + "=";
        this.calcHasResult = true;
      } catch {
        this.calcDisplay = "Error";
        this.calcExpression = "";
        this.calcHasResult = true;
      }
    },
    formatDate(date) {
      const event = new Date(date);
      return event.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    formatDateTime(date) {
      const event = new Date(date);
      return (
        event.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }) + " น."
      );
    },
    // toggleCamera() {
    //   if (isCameraOpen.value) {
    //     isCameraOpen.value = false;
    //     this.stopCameraStream();
    //   } else {
    //     isCameraOpen.value = true;
    //     this.createCameraElement();
    //   }
    //   //  createCameraElement();
    //   //  stopCameraStream();
    // },
    // createCameraElement() {
    //   isCameraOpen.value = true;
    //   if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    //     navigator.mediaDevices
    //       .getUserMedia({ video: true, audio: false })
    //       .then((stream) => {
    //         video.value.srcObject = stream;
    //         video.value.play();
    //         this.startTimer(5 * 60);
    //         this.checkCamera();
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //         Swal.fire({
    //           title: "กรุณาให้สิทธิ webcam ในการทำข้อสอบ",
    //           icon: "warning",
    //           showCancelButton: true,
    //           confirmButtonColor: "#323563",
    //           cancelButtonColor: "#d33",
    //           confirmButtonText: "เข้าใจและเริ่มทำข้อสอบ",
    //           allowOutsideClick: false,
    //           cancelButtonText: "กลับสู่หน้าหลัก",
    //         }).then((result) => {
    //           if (result.isConfirmed) {
    //             this.createCameraElement();
    //           } else {
    //             router.push({
    //               name: "voluntary-detail",
    //               params: { id: this.$route.params.exrId },
    //             });
    //           }
    //         });
    //       });
    //   }
    // },
    // stopCameraStream() {
    //   video.value = video.value.srcObject.getTracks();
    //   video.value.forEach((track) => {
    //     track.stop();
    //   });
    // },
    // capture() {
    //   /* eslint-disable */
    //   canvas.value = this.$refs.canvas;
    //   var context: any = canvas.value
    //     .getContext("2d")
    //     .drawImage(this.video, 0, 0, 640, 480);
    //   console.log(canvas.value.toDataURL("image/png"));
    //   captures.value.push(canvas.value.toDataURL("image/png"));
    //   // this.captures.push(canvas.value.toDataURL("image/png"));
    //   /* eslint-disable */
    // },
    startTimer(secs) {
      this.timeInSecs = parseInt(secs);
      this.ticker = window.setInterval(() => {
        this.tick();
      }, 1000);
    },
    tick() {
      let secs = this.timeInSecs;
      cookies.set("time", secs + "");
      if (secs > 0) {
        this.timeInSecs--;
      } else {
        clearInterval(this.ticker);
        submitButton.value = true;
        this.submit(true);
        // Swal.fire({
        //   title: "หมดเวลาทำข้อสอบแล้ว!",
        //   text: "ต้องการส่งคำตอบหรือไม่ ?",
        //   icon: "error",
        //   buttonsStyling: false,
        //   showCancelButton: true,
        //   allowOutsideClick: false,
        //   confirmButtonText: "ส่งคำตอบ",
        //   cancelButtonText: "ยกเลิก",
        //   customClass: {
        //     confirmButton: "btn fw-semibold btn-primary btn-lg",
        //     cancelButton: "btn fw-semibold btn-light-danger btn-sm",
        //   },
        // }).then((result) => {
        //   if (result.isConfirmed) {
        //     this.submit();
        //   } else {
        //     submitButton.value = false;
        //     this.$router.go(-1);
        //   }
        // });
      }
      const mins = Math.floor(secs / 60);
      secs %= 60;
      const pretty =
        (mins < 10 ? "0" : "") + mins + ":" + (secs < 10 ? "0" : "") + secs;
      this.countdown = pretty;
    },
    percentageToDegrees(percentage) {
      return (percentage / 100) * 360;
    },
    async submit(skipConfirm = false) {
      submitButton.value = true;
      if (skipConfirm) {
        this.doSubmit();
        return;
      }
      Swal.fire({
        title: "ต้องการส่งคำตอบใช่หรือไม่",
        icon: "warning",
        buttonsStyling: false,
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: "ส่งคำตอบ",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn fw-semibold btn-primary btn-lg",
          cancelButton: "btn fw-semibold btn-light-danger btn-sm",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.doSubmit();
        } else {
          submitButton.value = false;
        }
      });
    },
    doSubmit() {
      Swal.fire({
        title: "กำลังดำเนินการ...",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      clearInterval(this.ticker);
      clearInterval(this.checkPermission);
      const examId = this.$route.params.exId;
      const syllabusRegisterId = this.$route.params.sbId;
      const examRoomId = this.$route.params.exrId;
      const timeSubmit = this.calcTimeSubmit();
      score.value = 0;
      axios
        .post(
          process.env.VUE_APP_API_URL +
            "/checkAnswer?examId=" +
            this.$route.params.exId +
            "&syllabusId=" +
            currentSyllabusId.value +
            "&examRoomId=" +
            this.$route.params.exrId,
          answersList.value,
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          },
        )
        .then((res) => {
          if (res.data.status == 400) {
            submitButton.value = false;
            Swal.fire({
              title: "เกิดข้อผิดพลาด",
              text: res.data.message,
              icon: "error",
              confirmButtonColor: "#323563",
              confirmButtonText: "กลับสู่หน้าหลัก",
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                router.push({
                  name: "mandatory-list",
                  params: { id: currentSyllabusId.value },
                });
              }
            });
            return;
          }
          score.value = res.data.data.score;
          const formData = new FormData();
          formData.append("score", score.value + "");
          formData.append("examId", examId + "");
          formData.append("syllabusRegisterId", syllabusRegisterId + "");
          formData.append("examRoomId", examRoomId + "");
          // console.log("checkAnswer");
          axios
            .post(process.env.VUE_APP_API_URL + "/updateScore", formData, {
              headers: {
                token: localStorage.getItem("id_token"),
              },
            })
            .then(async (res) => {
              Swal.close();
              localStorage.removeItem(
                "ExamQuestion_" +
                  localStorage.getItem("u_id") +
                  "_" +
                  this.$route.params.exId +
                  "_" +
                  this.$route.params.exrId,
              );

              localStorage.removeItem(this.answersListKey);
              cookies.remove("examRoomId");
              cookies.remove("examId");
              cookies.remove("time");
              cookies.remove("userAnswerId");
              let percent = await this.formatNumber(
                (score.value / listData.value.length) * 100,
              );

              this.currentScore = listData.value.length;
              this.currentScoreUser = score.value;
              this.currentPercent = percent;
              this.currentTimeSubmit = timeSubmit;
              currentSyllabusId.value = res.data.data.syllabusId;

              const passed = percent >= this.percentPass;
              resultData.value = {
                passed,
                title: "ส่งคำตอบเรียบร้อยแล้ว",
                subtitle: "โปรดติดต่อเจ้าหน้าที่ห้องสอบ",
                totalQuestion: listData.value.length,
                totalScore: listData.value.length,
                percentPass: this.percentPass,
                timeSubmit,
                userScore: score.value,
                percent,
              };
              await this.updateProgress();
              // dialogVisible.value = true;
              //   Swal.fire({
              //     title: `<strong>${
              //       percent >= this.myExam["percentPass"]
              //         ? "ยินดีด้วย คุณผ่านการทดสอบ!"
              //         : "เสียใจด้วย คุณไม่ผ่านการทดสอบ"
              //     }</strong>`,
              //     html: `${
              //       percent >= this.myExam["percentPass"]
              //         ? "กรุณารอการตรวจสอบข้อมูลจากเจ้าหน้าที่ และจะได้รับใบรับรองทันทีหลังข้อมูลได้รับการอนุมัติ"
              //         : "โปรดติดต่อเจ้าหน้าที่ เพื่อขอทำการทดสอบอีกครั้งโดยจะต้องทำการจองเพื่อขอสอบผ่านระบบเท่านั้น"
              //     }<br>
              //  <br>
              //   <div class="card">
              //     <div class="card-body">
              //        <p style="text-align: left;"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
              //           <path d="M17.6423 2.21644C17.045 2.11355 16.4401 2.06059 15.834 2.05811C13.7659 2.05641 11.741 2.64942 10.0006 3.76644C8.25576 2.66409 6.23118 2.08563 4.16731 2.09978C3.56118 2.10226 2.95631 2.15522 2.35897 2.25811C2.16331 2.29184 1.98612 2.39432 1.85932 2.5471C1.73251 2.69988 1.66442 2.89292 1.66731 3.09144V13.0914C1.66552 13.2139 1.69075 13.3352 1.74118 13.4468C1.79162 13.5584 1.86603 13.6575 1.95912 13.7371C2.05221 13.8166 2.16169 13.8747 2.27977 13.9071C2.39785 13.9396 2.52163 13.9456 2.64231 13.9248C3.83649 13.718 5.05998 13.7523 6.2407 14.0257C7.42142 14.299 8.53549 14.8059 9.51731 15.5164L9.61731 15.5748H9.70897C9.80139 15.6133 9.90052 15.6331 10.0006 15.6331C10.1008 15.6331 10.1999 15.6133 10.2923 15.5748H10.384L10.484 15.5164C11.4589 14.79 12.5698 14.2667 13.7508 13.9776C14.9317 13.6884 16.1587 13.6393 17.359 13.8331C17.4796 13.8539 17.6034 13.8479 17.7215 13.8155C17.8396 13.783 17.9491 13.725 18.0422 13.6454C18.1353 13.5658 18.2097 13.4667 18.2601 13.3551C18.3105 13.2436 18.3358 13.1222 18.334 12.9998V2.99978C18.3253 2.8099 18.252 2.6287 18.1262 2.48622C18.0004 2.34375 17.8296 2.24856 17.6423 2.21644ZM9.16731 13.2914C7.62554 12.4803 5.90941 12.057 4.16731 12.0581C3.89231 12.0581 3.61731 12.0581 3.33397 12.0581V3.72478C3.61152 3.70878 3.88976 3.70878 4.16731 3.72478C5.94513 3.72281 7.68415 4.24452 9.16731 5.22478V13.2914ZM16.6673 12.0914C16.384 12.0914 16.109 12.0914 15.834 12.0914C14.0919 12.0904 12.3757 12.5137 10.834 13.3248V5.22478C12.3171 4.24452 14.0562 3.72281 15.834 3.72478C16.1115 3.70878 16.3898 3.70878 16.6673 3.72478V12.0914ZM17.6423 15.5498C17.045 15.4469 16.4401 15.3939 15.834 15.3914C13.7659 15.3897 11.741 15.9828 10.0006 17.0998C8.26024 15.9828 6.23534 15.3897 4.16731 15.3914C3.56118 15.3939 2.95631 15.4469 2.35897 15.5498C2.2505 15.567 2.14649 15.6055 2.05294 15.663C1.95939 15.7206 1.87814 15.7961 1.81386 15.8851C1.74958 15.9742 1.70354 16.0751 1.67839 16.182C1.65324 16.2889 1.64947 16.3997 1.66731 16.5081C1.70966 16.7245 1.83605 16.9153 2.0188 17.0387C2.20155 17.1621 2.42576 17.208 2.64231 17.1664C3.83649 16.9597 5.05998 16.994 6.2407 17.2673C7.42142 17.5407 8.53549 18.0476 9.51731 18.7581C9.65844 18.8586 9.82739 18.9126 10.0006 18.9126C10.1739 18.9126 10.3428 18.8586 10.484 18.7581C11.4658 18.0476 12.5799 17.5407 13.7606 17.2673C14.9413 16.994 16.1648 16.9597 17.359 17.1664C17.5755 17.208 17.7997 17.1621 17.9825 17.0387C18.1652 16.9153 18.2916 16.7245 18.334 16.5081C18.3518 16.3997 18.348 16.2889 18.3229 16.182C18.2977 16.0751 18.2517 15.9742 18.1874 15.8851C18.1231 15.7961 18.0419 15.7206 17.9483 15.663C17.8548 15.6055 17.7508 15.567 17.6423 15.5498Z" fill="#6B6B6B"/>
              //         </svg>จำนวนข้อสอบ : ${this.myExam["totalQuestion"]} ข้อ
              //         </p>
              //        <p style="text-align: left;"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
              //           <path d="M16.6654 7.94984C16.6567 7.87328 16.6399 7.79786 16.6154 7.72484V7.64984C16.5753 7.56415 16.5219 7.48539 16.457 7.4165L11.457 2.4165C11.3881 2.35168 11.3094 2.29824 11.2237 2.25817C11.1988 2.25464 11.1736 2.25464 11.1487 2.25817C11.064 2.20962 10.9706 2.17846 10.8737 2.1665H5.83203C5.16899 2.1665 4.53311 2.4299 4.06426 2.89874C3.59542 3.36758 3.33203 4.00346 3.33203 4.6665V16.3332C3.33203 16.9962 3.59542 17.6321 4.06426 18.1009C4.53311 18.5698 5.16899 18.8332 5.83203 18.8332H14.1654C14.8284 18.8332 15.4643 18.5698 15.9331 18.1009C16.402 17.6321 16.6654 16.9962 16.6654 16.3332V7.99984C16.6654 7.99984 16.6654 7.99984 16.6654 7.94984ZM11.6654 5.00817L13.8237 7.1665H12.4987C12.2777 7.1665 12.0657 7.07871 11.9094 6.92243C11.7532 6.76615 11.6654 6.55418 11.6654 6.33317V5.00817ZM14.9987 16.3332C14.9987 16.5542 14.9109 16.7661 14.7546 16.9224C14.5983 17.0787 14.3864 17.1665 14.1654 17.1665H5.83203C5.61102 17.1665 5.39906 17.0787 5.24278 16.9224C5.0865 16.7661 4.9987 16.5542 4.9987 16.3332V4.6665C4.9987 4.44549 5.0865 4.23353 5.24278 4.07725C5.39906 3.92097 5.61102 3.83317 5.83203 3.83317H9.9987V6.33317C9.9987 6.99621 10.2621 7.6321 10.7309 8.10094C11.1998 8.56978 11.8357 8.83317 12.4987 8.83317H14.9987V16.3332ZM11.907 10.7415L9.16536 13.4915L8.09036 12.4082C7.93344 12.2513 7.72062 12.1631 7.4987 12.1631C7.27678 12.1631 7.06395 12.2513 6.90703 12.4082C6.75011 12.5651 6.66195 12.7779 6.66195 12.9998C6.66195 13.2218 6.75011 13.4346 6.90703 13.5915L8.5737 15.2582C8.65117 15.3363 8.74333 15.3983 8.84488 15.4406C8.94643 15.4829 9.05535 15.5047 9.16536 15.5047C9.27537 15.5047 9.3843 15.4829 9.48585 15.4406C9.58739 15.3983 9.67956 15.3363 9.75703 15.2582L13.0904 11.9248C13.2473 11.7679 13.3354 11.5551 13.3354 11.3332C13.3354 11.1113 13.2473 10.8984 13.0904 10.7415C12.9334 10.5846 12.7206 10.4964 12.4987 10.4964C12.2768 10.4964 12.064 10.5846 11.907 10.7415Z" fill="#6B6B6B"/>
              //         </svg>คะแนนเต็ม : ${this.myExam["totalScore"]} คะแนน
              //         </p>
              //        <p style="text-align: left;"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
              //           <path d="M12.268 7.82484L8.69297 11.4082L7.31797 10.0332C7.24327 9.94594 7.15133 9.87509 7.04795 9.82507C6.94456 9.77505 6.83195 9.74694 6.71718 9.74251C6.60242 9.73807 6.48797 9.75741 6.38104 9.79931C6.2741 9.8412 6.17698 9.90475 6.09576 9.98596C6.01455 10.0672 5.951 10.1643 5.90911 10.2712C5.86721 10.3782 5.84787 10.4926 5.85231 10.6074C5.85674 10.7221 5.88485 10.8348 5.93487 10.9381C5.98489 11.0415 6.05574 11.1335 6.14297 11.2082L8.10131 13.1748C8.17917 13.2521 8.27152 13.3132 8.37305 13.3546C8.47458 13.3961 8.5833 13.4171 8.69297 13.4165C8.91159 13.4156 9.12109 13.3288 9.27631 13.1748L13.443 9.00817C13.5211 8.9307 13.5831 8.83853 13.6254 8.73698C13.6677 8.63544 13.6895 8.52651 13.6895 8.4165C13.6895 8.30649 13.6677 8.19757 13.6254 8.09602C13.5831 7.99447 13.5211 7.90231 13.443 7.82484C13.2868 7.66963 13.0756 7.58251 12.8555 7.58251C12.6353 7.58251 12.4241 7.66963 12.268 7.82484ZM10.0013 2.1665C8.35313 2.1665 6.74196 2.65525 5.37155 3.57092C4.00114 4.4866 2.93304 5.78809 2.30231 7.31081C1.67158 8.83353 1.50655 10.5091 1.8281 12.1256C2.14964 13.7421 2.94331 15.227 4.10875 16.3924C5.27419 17.5578 6.75905 18.3515 8.37555 18.673C9.99206 18.9946 11.6676 18.8296 13.1903 18.1988C14.7131 17.5681 16.0145 16.5 16.9302 15.1296C17.8459 13.7592 18.3346 12.148 18.3346 10.4998C18.3346 9.40549 18.1191 8.32186 17.7003 7.31081C17.2815 6.29976 16.6677 5.3811 15.8939 4.60728C15.12 3.83346 14.2014 3.21963 13.1903 2.80084C12.1793 2.38205 11.0957 2.1665 10.0013 2.1665ZM10.0013 17.1665C8.68276 17.1665 7.39383 16.7755 6.2975 16.043C5.20118 15.3104 4.34669 14.2692 3.84211 13.0511C3.33752 11.8329 3.2055 10.4924 3.46274 9.19924C3.71997 7.90603 4.35491 6.71814 5.28726 5.78579C6.21961 4.85344 7.4075 4.2185 8.7007 3.96127C9.99391 3.70403 11.3344 3.83606 12.5525 4.34064C13.7707 4.84522 14.8119 5.69971 15.5444 6.79604C16.277 7.89236 16.668 9.1813 16.668 10.4998C16.668 12.2679 15.9656 13.9636 14.7154 15.2139C13.4651 16.4641 11.7694 17.1665 10.0013 17.1665Z" fill="#6B6B6B"/>
              //         </svg>เกณฑ์การผ่าน : ${this.myExam["percentPass"]}
              //         </p>
              //        <div class="d-flex">
              //           <div class="w-50" style="text-align: left;">
              //            <b>คะแนนของคุณคือ</b>
              //            <p>${score.value}/${
              //       this.myExam["totalQuestion"]
              //     } คะแนน</p>
              //            <p>เวลาในการทำข้อสอบ : ${timeSubmit} นาที</p>
              //           </div>
              //            <div class="progressbar w-50">
              //             <div class="percent">
              //               <svg>
              //                 <circle cx="50" cy="50" r="40"></circle>
              //                 <circle cx="50" cy="50" r="40" style="--percent: ${percent}"></circle>
              //               </svg>
              //               <div class="number">
              //                 <h3>${percent}<span>%</span></h3>
              //               </div>
              //             </div>
              //           </div>
              //        </div>
              //     </div>
              //   </div>

              // `,
              //     showCloseButton: false,
              //     icon:
              //       percent >= this.myExam["percentPass"]
              //         ? "success"
              //         : "error",
              //     showCancelButton: false,
              //     allowOutsideClick: false,
              //     focusConfirm: false,
              //     confirmButtonText:
              //       '<i class="fa fa-thumbs-up"></i> เข้าใจแล้ว',
              //   }).then(async (result) => {
              //     if (result.isConfirmed) {
              //       await this.updateProgress();
              //     }
              //   });
            })
            .catch((error) => {
              // console.log(error);
              submitButton.value = false;
              Swal.fire({
                title: "แจ้งเตือนข้อผิดพลาด",
                text: error.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-danger",
                },
              });
            });
        })
        .catch((error) => {
          // console.log(error);
          submitButton.value = false;
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    },
    async getCourseRegister(courseId) {
      const courseRegisterId = await axios.get(
        process.env.VUE_APP_API_URL +
          "/getCourseRegister?courseId=" +
          courseId +
          "&userId=" +
          localStorage.getItem("u_id"),
        {
          headers: {
            token: localStorage.getItem("id_token"),
          },
        },
      );
      // console.log(courseRegisterId.data.data);
      return courseRegisterId.data.data.content[0].id;
    },
    async updateProgress() {
      const formData = new FormData();
      formData.append(
        "examRoomCode",
        this.examRoomProfile["examRoomCode"] + "",
      );
      // console.log("update");
      await axios
        .post(
          process.env.VUE_APP_API_URL + "/endTestExamRoomRegister",
          formData,
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          },
        )
        .then((res) => {
          dialogVisible.value = true;
          // console.log(res);
        })
        .catch((error) => {
          // console.log(error);
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    },
    formatNumber(score) {
      return parseInt(score);
    },
    forceRerender() {
      this.componentKey += 1;
    },
    onBack() {
      submitButton.value = false;
      dialogVisible.value = false;
      localStorage.setItem("reloaded", "1");
      if (
        localStorage.getItem("typeLogin") &&
        localStorage.getItem("typeLogin") != undefined &&
        localStorage.getItem("typeLogin") == "idcard"
      ) {
        router.push({
          name: "my-exam",
        });
      } else {
        router.push({
          name: "course-list",
          params: { id: currentSyllabusId.value },
        });
      }

      // router.go(-1);
    },
    calcRemainSecs() {
      const endDate = this.examRoomProfile["endDate"];
      if (!endDate) {
        return this.examRoomProfile["examProfile"].limitTime * 60;
      }
      return Math.max(
        0,
        Math.floor((new Date(endDate).getTime() - Date.now()) / 1000),
      );
    },
    calcTimeSubmit() {
      if (!this.startTestDate) return "00 : 00";
      const usedSecs = Math.max(
        0,
        Math.floor(
          (Date.now() - new Date(this.startTestDate).getTime()) / 1000,
        ),
      );
      let minutes: any = Math.floor(usedSecs / 60);
      let extraSeconds: any = usedSecs % 60;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      extraSeconds = extraSeconds < 10 ? "0" + extraSeconds : extraSeconds;
      return minutes + " : " + extraSeconds;
    },
  },
  beforeUnmount() {
    Swal.close();
    localStorage.setItem("reloaded", "1");
    clearInterval(this.ticker);
  },
});
</script>
<style>
.result-dialog {
  width: 100% !important;
}
.score-flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.score-text {
  inline-size: 100%;
  text-align: start;
}
.score-progress {
  display: flex;
  justify-content: center;
}

span.green {
  background: #5ea226;
  border-radius: 0.8em;
  -moz-border-radius: 0.8em;
  -webkit-border-radius: 0.8em;
  color: #ffffff;
  display: inline-block;
  font-weight: bold;
  line-height: 1.6em;
  margin-left: 35px;
  text-align: center;
  width: 1.6em;
}
span.grey {
  background: #cccccc;
  border-radius: 0.8em;
  -moz-border-radius: 0.8em;
  -webkit-border-radius: 0.8em;
  color: #fff;
  display: inline-block;
  font-weight: bold;
  line-height: 1.6em;
  margin-left: 35px;
  text-align: center;
  width: 1.6em;
}
.btn-app {
  background: #da595a;
  color: #ffffff;
  border-radius: 100px;
}
.btn-app2 {
  background: #323563;
  color: #ffffff;
  border-radius: 100px;
}
.btn-exam {
  color: #109448;
  background: #ffffff;
  border: 1px solid #109448 !important;
  width: 160px;
  border-radius: 10px;
}
.btn-exam:hover {
  color: #ffffff;
  background: #109448;
  border-radius: 10px;
}
.btn-exam:disabled {
  background: #e5e5e5;
  color: #979797;
  border: 1px solid #d8d8d8 !important;
  border-radius: 10px;
}
.btn-register {
  background: #f2a17d;
  color: #ffffff;
  width: 70%;
  border-radius: 21px;
}
.calc-btn {
  padding: 14px 0;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  background: #2a2a4a;
  color: #fff;
  transition: background 0.15s;
}
.calc-btn:hover {
  background: #3a3a6a;
}
.calc-btn-fn {
  background: #3d3d5c;
  color: #f2a17d;
}
.calc-btn-fn:hover {
  background: #4d4d6c;
}
.calc-btn-op {
  background: #f2a17d;
  color: #fff;
}
.calc-btn-op:hover {
  background: #e08c5c;
}
.calc-btn-eq {
  background: #323563;
  color: #fff;
  padding: 12px 0;
  font-size: 20px;
}
.calc-btn-eq:hover {
  background: #434794;
}
</style>
